import { render, staticRenderFns } from "./DialogFormActivityTypeEdit.vue?vue&type=template&id=57445323"
import script from "./DialogFormActivityTypeEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormActivityTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports